import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"

const SubcontractorsPage = lazyPage(
  () => import("../../../SubcontractorsPage/SubcontractorsPage.tsx")
)

const SubcontractorDetailPage = lazyPage(
  () => import("../../../SubcontractorsPage/SubcontractorDetailPage")
)
export const subcontractorRoutes: RouteObject[] = [
  {
    path: RoutesPaths.subcontractors.list,
    element: (
      <PermissionGate pages={["subcontractors"]}>
        <SubcontractorsPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.subcontractors.view(":id"),
    element: (
      <PermissionGate pages={["subcontractors"]}>
        <SubcontractorDetailPage />
      </PermissionGate>
    )
  }
]
